// eslint-disable-next-line import/prefer-default-export
export enum AuthStatus {
  ACTIVE = 'active',
  PENDING = 'pending',
  FAILED = 'failed',
}
